<template>
    <v-card>                
        <v-toolbar flat color="primary" class="white--text">
            <v-toolbar-title>Season Start and End Dates</v-toolbar-title>
            <v-spacer></v-spacer>                    
        </v-toolbar>
        <v-layout wrap>
            <v-flex xs12 sm3 offset-sm1>
                <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 sm2 offset-sm1>
                <v-btn color="primary" block @click="openEdit(null)">
                    Add
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :rows-per-page-items="rowsPerPageItems" 
                    :pagination.sync="pagination"
                    :search="search"
                    :loading="loading"
                    :items="data">
                    <template v-slot:items="{ item }">                        
                        <td>{{ item.ProductCategoryName }}</td>                        
                        <td>{{ item.SeasonStartDate | formatDate }}</td>
                        <td>{{ item.SeasonEndDate | formatDate }}</td>
                        <td>
                            <v-btn 
                                color="primary"
                                block 
                                @click="openEdit(item)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                        <td>
                            <v-btn color="error" block @click.stop="checkConfirmDelete(item.PlantSeasonID)" :loading="loading">
                                <span>Delete</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
                <v-dialog :value="seasonIDToDelete != null" max-width="290" persistent @keydown.esc="cancelDelete">
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>Confirm Delete</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <span>Are you sure you want to delete this season?</span>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn @click="cancelDelete">Cancel</v-btn>
                            <v-btn color="error" @click="confirmDelete" :loading="loading">Delete</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-flex>
        </v-layout>
    </v-card>
</template>
<script>
import plantConfigurationApi from "@/api/plantConfigurationApi";

export default {
    props: {
        data: {
            type: Array,
            required: true
        }
    },
    data() {
        return {            
            loading: false,
            search: '',
            rowsPerPageItems: [10, 25, 50, 100],
            seasonIDToDelete: null,
            pagination: {
                page: 1,
                rowsPerPage: 25,
                descending: false
            },
            headers: [
                {
                    text: "Product Category",
                    value: "ProductCategoryName",
                    sortable: true
                },
                {
                    text: "Season Start Date",
                    value: "SeasonStartDate",
                    sortable: true
                },
                {
                    text: "Season End Date",
                    value: "SeasonEndDate",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "",
                    sortable: false
                }
            ]
        }
    },
    computed: {
    },
    methods: {
        openEdit(item) {
            this.$emit("edit", item);
        },
        checkConfirmDelete(id) {
            this.seasonIDToDelete = id;
        },
        cancelDelete() {
            this.finishConfirmDelete();
        },
        async confirmDelete() {
            await this.deleteItem(this.seasonIDToDelete);
            
            this.finishConfirmDelete();
        },
        finishConfirmDelete() {
            this.seasonIDToDelete = null;
        },
        async deleteItem(id) {
            this.loading = true;

            var result = await plantConfigurationApi.deletePlantSeason(id);
            
            var errorMessage = null;
            if (!result.Success) {
                errorMessage = result.ErrorMessages.join(', ');
            }
            this.$emit("deleteComplete", errorMessage);

            this.loading = false;
        },
    }
}
</script>